<app-navbar [title]="pageTitle">
	<button class="btn btn-primary me-3" (click)="submit()">Zapisz i wyjdź</button>
	<a class="btn btn-danger" routerLink="../"> <i class="fas fa-chevron-left"></i> Powrót </a></app-navbar
>
<div class="container my-4">
	<form (submit)="submit()">
		<fieldset>
			<div class="form-floating mb-3">
				<input type="text" id="name" class="form-control" name="name" [(ngModel)]="data.name" required />
				<label for="name" class="form-label">Nazwa<small class="ms-2 text-danger">* wymagane</small></label>
			</div>
			<div class="d-flex justify-content-between">
				<div class="form-floating mb-3 me-3 w-50">
					<input type="text" id="fee" class="form-control" name="fee" [(ngModel)]="data.fee" required />
					<label for="fee" class="form-label"
						>Prowizja (wartość %)<small class="ms-2 text-danger">* wymagane</small></label
					>
				</div>
				<div class="mb-3 ms-3 w-50">
					<ng-select
						id="use"
						name="use"
						class="custom-ng-select"
						[(ngModel)]="data.use"
						placeholder="Licz od całości"
						required
					>
						<ng-option *ngFor="let item of isActiveOptions" [value]="item.use">{{ item.name }}</ng-option>
					</ng-select>
				</div>
			</div>
		</fieldset>
	</form>
</div>
